import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { FilterInnerContainer, OpenSection } from 'components/filters/styled/dropdown';


export const FilterTitle = styled(Text)`
  ${({ theme }) => `
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const FilterInnerRoot = styled.div`
  ${({ theme }) => `
    label {
      margin-bottom: ${theme.spacing(2)};
    }
  `}
`;

export const InnerContainer = styled(FilterInnerContainer)`
  ${({ theme }) => `
    &&& {
      max-height: 290px;
      padding: ${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(1)};
    }
  `}
`;

export const DropdownSection = styled(OpenSection)`
  transform: translate(97px, 0);
`;
